
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_936piPEyTTWZfknx1wdqJl2TBSOVh6XbdCo0dzPYo4wYwMeta } from "/codebuild/output/src2900687957/src/ark/pages/[...slug].vue?macro=true";
import { default as guias5M4mN6mwTGjwDi2P4sWuFPnMn4j_6y_PhsPyV7kigsEMeta } from "/codebuild/output/src2900687957/src/ark/pages/blog/guias.vue?macro=true";
import { default as index8x2FmKp8swC1OjqF4aaVmvQJVQ4i_yh7mP2etqtEOOYMeta } from "/codebuild/output/src2900687957/src/ark/pages/blog/index.vue?macro=true";
import { default as temas1eplOJ_45M1_bDSHOSroRYIucvk_ObNYIGxJ2x0sRsEg4Meta } from "/codebuild/output/src2900687957/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisaykyG_KnhJepaBkL066RpfLktVlS3fOspKE2WXsX5zmAMeta } from "/codebuild/output/src2900687957/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradawhc6kjgbEJxl19r1nHLGrMZyIF4Z32XSdumIfDvYGl0Meta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesKzj1pKibu3XgT3jG3ma1YRwpro3Xaa75Fdl8dEHRfYIMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gas_WKxIiOHqvq0NBBZp6eKJJgSVcm7jPDqMuycOHyEfWEMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casa4P16bqG7Mh24zddXEReZTqUzXKrDmC3GVPbnteQURHYMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtorGkFHy0sj7szC7pHzOq_wUGRDQ6G2bWAL6mfIZ0CKIsMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraumfaJ0n65f9qJxY7UzxhCJ1W6oahD9UMTeGkn5vSqtwMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contacto90UBYciF0ZYJMV4rMpv1ReT_2Ys9k2kvnDIhXwsgL0QMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaqnukU0CBOh8nUFApBtg1ozo1ObcSfD1RW1GrWNE9LosMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularqYgHc7J8QgGSmg5CAebJgF73EGApvfewa4_457Kxmk_f8Meta } from "/codebuild/output/src2900687957/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetLRUuJUbArfqM_45hbQiVTWwc0OiIE1t2HOmg8B8gcs5TUMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelM49imXDjb2JBfOfVNagUFRdxyA5zLApHEXW2WJoyVPkMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacao0qZXkG6DAW6BSFjI2p7OoXUEUmSOGuo8_41iOJabTKoMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atuald4k7FfXttD5L7RPN_45_DbV_0uqK_45RWfN2D22VGwrP_45KMMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoP3tC9GWATqxKbvdSPZLU56RewXcvOIbkm73jNhVhBBUMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularnefjcGapgHnjqfgZCdIPOZLvHHB9P3ypGMuPCmfWPx8Meta } from "/codebuild/output/src2900687957/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93VJyJt3PjnmCp2mMvym8Y_pH_457GH2gPinEb4DgpqwRx4Meta } from "/codebuild/output/src2900687957/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93WxGtKKNEUnSr0sZI353qVNXP9jIoaxTgnSFkxeHOCgkMeta } from "/codebuild/output/src2900687957/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoXkffR_459x7_45g3Q6rj7mKic1tq3QaMve5brlEZb1w8z9wMeta } from "/codebuild/output/src2900687957/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidade4KRd9GdiTva0pj8zA50Up9YyijFINEnpHmpKbHgpGQMMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxanL_rDHFvDVheCh5fyxg9lpWy2POXmUC7oX_VLNzjZM0Meta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactoI4FRXwvLnMEU8fEziRGDW2Ih3wJj1hAdDar1b2GCMLcMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processohmmK3ug_tQa0Sae2oR8cWKARX4Fi3z9asyw9911OuwYMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeira0Ta8r8SdCsZ2x3DiMp_KtqF1k_45rd35OpAFecp85wFuAMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimo0nq29kECs6GENC0NcIp6Wf4S0syjCJPp5hwvd0U97fYMeta } from "/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simular_457CPXxtkYPAUMJ2P4H5xkU_LCWWjsk6AN_45GYSFqGxq8Meta } from "/codebuild/output/src2900687957/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93rTnTR_LUts8VkLEnI742mFIQvcN8dGbPdvgqI1hXlzcMeta } from "/codebuild/output/src2900687957/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadossnoViB4K_45EEuav07AsBh0Q_45yL9KNqnbv3JF50iJQpEEMeta } from "/codebuild/output/src2900687957/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexCqpWEOYFrPGP2Xgs0E1rFxFbnrE86QvJpbv5M5JntG4Meta } from "/codebuild/output/src2900687957/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93JGiFyuGjlbwr_XpZZpvihIy5t6AnR4817QEEy2SZcUAMeta } from "/codebuild/output/src2900687957/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93XsEu4c5ch_YVuR5TVJzCAvcQpCMOR7nBMT7RBbQMTtIMeta } from "/codebuild/output/src2900687957/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simularqYgHc7J8QgGSmg5CAebJgF73EGApvfewa4_457Kxmk_f8Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularnefjcGapgHnjqfgZCdIPOZLvHHB9P3ypGMuPCmfWPx8Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simular_457CPXxtkYPAUMJ2P4H5xkU_LCWWjsk6AN_45GYSFqGxq8Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src2900687957/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93rTnTR_LUts8VkLEnI742mFIQvcN8dGbPdvgqI1hXlzcMeta || {},
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadossnoViB4K_45EEuav07AsBh0Q_45yL9KNqnbv3JF50iJQpEEMeta || {},
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93JGiFyuGjlbwr_XpZZpvihIy5t6AnR4817QEEy2SZcUAMeta || {},
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93XsEu4c5ch_YVuR5TVJzCAvcQpCMOR7nBMT7RBbQMTtIMeta || {},
    component: () => import("/codebuild/output/src2900687957/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]